import { render, staticRenderFns } from "./CreateFormGoods.vue?vue&type=template&id=275431f5"
import script from "./CreateFormGoods.vue?vue&type=script&lang=js"
export * from "./CreateFormGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports